import { observable, computed, action, makeObservable/*, toJS*/ } from "mobx";
import { getMobileOrderNo, expectTime } from "utils/Utils"

class OrderStore {

    constructor() {
        makeObservable(this);
    }

    /*********************/
    /* 페이징 객체         */
    /*********************/
    /**
     * 페이징 객체
     * @type {{page_no: number, max_page: number}}
     * @private
     */
    @observable
    _st_paging_info = {
        page_no: 1,
        max_page: 1,
        end_max_page: 1,
    }

    /**
     * 페이징 객체 조회
     * @returns {{page_no: number, max_page: number}}
     */
    get getPagingInfo() {
        return this._st_paging_info;
    }

    /**
     * 페이징 객체 값 셋팅
     * @param key
     * @param value
     */
    @action
    setPagingInfo(key, value) {
        this._st_paging_info = { ...this._st_paging_info, [key]: value };
    }

    /**
     * 다음페이지 이동
     */
    @action
    nextPage() {
        const max_page = this._st_paging_info.max_page;
        let page_no = this._st_paging_info.page_no;

        if (page_no < max_page) {
            this._st_paging_info.page_no = (page_no + 1)
        }
    }

    /**
     * 페이지 초기화
     */
    @action
    setInitPage() {
        this._st_paging_info = {
            page_no: 1,
            max_page: 1
        }
    }

    /**
     * 이전페이징 이동
     */
    @action
    prevPage() {
        let page_no = this._st_paging_info.page_no;
        if (page_no > 1) {
            this._st_paging_info.page_no = (page_no - 1)
        }
    }


    /*********************/
    /* 주문 목록 리스트     */
    /*********************/
    /**
     * 주문 목록 객체 OBJ LIST
     * @type {[]}
     * @private
     */
    @observable
    _st_order_list = []

    /**
     * 주문 목록 조회
     * @returns {[]}
     */
    @computed
    get getOrderList() {
        return this._st_order_list;
    }

    /**
     * 주문 목록 초기화
     * @returns {*[]}
     */
    @action
    initOrderList() {
        return this._st_order_list = [];
    }

    /**
     * 주문 목록 리스트 셋팅
     * @param list_obj
     * @returns {*}
     */
    @action
    addOrderListAll(new_order_list, list_obj) {
        return this._st_order_list = list_obj.map(order => {
            if(order.elapseTime != null){
                order.time = expectTime(order.elapseTime)
            }
            if (Array.isArray(new_order_list) && new_order_list.length) {
                let check_no = new_order_list.find(new_order => {
                    return order.mobileOrderNo === new_order;
                });
                if (check_no === order.mobileOrderNo) {
                    order = this.viewMobileOrderNoCreate(order)
                    order = this.shopMessageUpdate(order)
                    order = this.deliveryStatUpdate(order)
                    return { ...order, new_yn: "Y", dlvAddrDetail: (order.dlvAddrDetail === null) ? "" : order.dlvAddrDetail }
                } else {
                    order = this.viewMobileOrderNoCreate(order)
                    order = this.shopMessageUpdate(order)
                    order = this.deliveryStatUpdate(order)
                    return { ...order, new_yn: "N", dlvAddrDetail: (order.dlvAddrDetail === null) ? "" : order.dlvAddrDetail }
                }

            } else {
                order = this.viewMobileOrderNoCreate(order)
                order = this.shopMessageUpdate(order)
                order = this.deliveryStatUpdate(order)
                return { ...order, new_yn: "N", dlvAddrDetail: (order.dlvAddrDetail === null) ? "" : order.dlvAddrDetail }
            }
        });
    }

    shopMessageUpdate(order) {
        if (order.shopMessage != null) {
            let message = ((order.shopMessage.replace(/`/g, '')).substring(order.shopMessage.indexOf("제]"))).split("|")
            if (order.mobileOrderFg === "08" || order.mobileOrderFg === "22" || order.mobileOrderFg === "25" || order.mobileOrderFg === "26") {
                if (order.shopMessage) {
                    return { ...order, shopMessage: message[0], dlvMessage: message[1] }
                }
            } else {
                return { ...order, shopMessage: message[0] }
            }
        } else {
            return order
        }
    }

    deliveryStatUpdate(order) {
        if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500" && order.stepType === "DELIVERY") {
            return order
        } else {
            return order
        }
    }

    viewMobileOrderNoCreate(order) {
        return getMobileOrderNo(order)
    }

    newOrderNotifyCreate(data) {
        return this.viewMobileOrderNoCreate(data)
    }

    @action
    removeOrderNew(mobileOrderNo) {
        this._st_order_list = this._st_order_list.map(order => {
            if (order.mobileOrderNo === mobileOrderNo) {
                return { ...order, new_yn: "N" }
            } else {
                return order
            }
        });
    }

    /**
     * 상세보기 객체로 리스트 객체 재설정
     * @param viewObj
     */
    @action
    addListByViewObj(viewObj) {
        this._st_order_list = this._st_order_list.map(order => {
            if (viewObj.mobileOrderNo === order.mobileOrderNo) {
                return viewObj;
            } else {
                return order;
            }
        });
    }

    @action
    changeOrderListDlv(data) {
        this._st_order_list = this._st_order_list.map(order => {
            if (data.mobileOrderNo === order.mobileOrderNo) {
                return {
                    ...order
                    , dlvStatusFg: data.dlvStatusFg
                    //, deliveryStatus: data.dlvStatusFg
                    , deliveryStatusView: data.dlvStatusView
                    , dlvReqTime: data.dlvReqTime
                    , dlvPickupTime: data.dlvPickupTime
                    , dlvDeliveryTime: data.dlvDeliveryTime
                    , ptnerRiderTel: data.ptnerRiderTel
                    , ptnerRiderNm: data.ptnerRiderNm
                }
            } else {
                return order;
            }
        });
    }

    /**
     * 리스트에 주문 추가 : 최대 10건 ( 리스트형 )
     * @param order
     * @returns {number}
     */
    @action
    addOrderList_listType(order) {
        if (this._st_order_list.length > 9) {
            this._st_order_list.length = 9;
        }
        return this._st_order_list.unshift(order);
    }

    /**
     * 리스트에 주문 추가 : 최대 8건 ( 카드형 )
     * @param order
     * @returns {number}
     */
    @action
    addOrderList_cardType(order) {
        if (this._st_order_list.length > 7) {
            this._st_order_list.length = 7;
        }
        return this._st_order_list.unshift(order);
    }

    /**
     * 1분마다 리스트 객체 시간 증가
     */
    @action
    setChangeOrderTime() {
        this._st_order_list = this._st_order_list.map(order => {

            if (order.stepCd !== "000") {
                let timePrefix = order.viewTimePrefix;
                let timeColor = "NORMAL";
                let time = order.viewTime;

                if (order.viewTimePrefix === "+") {
                    timeColor = "OVER";
                    if (order.viewTime < 99) {
                        time = Number(order.viewTime) + 1;
                    }
                } else {
                    time = Number(order.viewTime) - 1;
                    if (time > 10) {
                        timeColor = "NORMAL";
                    } else if (time < 11 && time >= 0) {
                        timeColor = "ALERT";
                    }
                    if (time === 0) {
                        timePrefix = "+";
                    }
                }
                return { ...order, viewTime: time, viewTimePrefix: timePrefix, timeColor: timeColor };
            } else {
                return { ...order };
            }
        });
    }

    /**
     * 수금 확인 - 자체배달 완료
     * @type {{}}
     * @private
     */
    @observable
    _st_check_deposit = { payFg: '', stepCd: '' }

    @computed
    get getCheckDeposit() {
        return this._st_check_deposit;
    }

    @action
    setcheckDeposit(obj) {
        this._st_check_deposit = obj;
    }

    /**
     * order list style set
     * @returns {[]}
     */
    @observable
    _st_order_list_style = [];


    @action
    getOrderListStyleForNo(mobileOrderNo) {
        let checkStyle;
        this._st_order_list_style.map((data) => {
            if (data.mobileOrderNo === mobileOrderNo) {
                checkStyle = data.onStyle;
            }
        })
        return checkStyle;
    }

    //@action
    get getOrderListStyle() {
        return this._st_order_list_style;
    }

    @action
    initOrderListStyle() {
        this._st_order_list_style = [];
    }

    @action
    changeOrderListStyle(mobileOrderNo) {
        this._st_order_list_style = this._st_order_list_style.map(order => {
            if (order.mobileOrderNo === mobileOrderNo) {
                return { ...order, onStyle: true };
            } else {
                return { ...order, onStyle: false }
            }
        })
    }

    @action
    setOrderListStyle(obj) {
        this._st_order_list_style = [...this._st_order_list_style, obj];
    }

    //채널리스트 페이징 처리
    @observable
    _st_channel_page_cnt = 1

    @computed
    get getChannelPageCnt() {
        return this._st_channel_page_cnt;
    }

    @action
    setChannelPageCnt(cnt) {
        this._st_channel_page_cnt = cnt;
    }

    @observable
    _st_order_channel_view = {
        channel: {
            baemin: false,      // 배민
            baemin1: false,     // 배민1
            yogiyo: false,      // 요기요
            yogiyoexpress: false,     // 익스프레스
            eats: false,     // 쿠팡
            wmpo: false,    	// 위메프오
            specialdelivery: false, // 배달특급
            ddangyo: false,     // 땡겨요
            mukkebi: false,     // 먹깨비
            daeguro: false,     // 대구로
            incheoneum: false,  // 인천이음
            baedalys: false,    // 배달양산
            etc: false,         // 기타
        },
        channelList: {
            0: [
                "baemin",
                "baemin1",
                "yogiyo",
                "yogiyoexpress",
                "eats",
                "wmpo",
                "specialdelivery",
                "ddangyo",
                "mukkebi",
                "daeguro"
            ],
            1: [
                "incheoneum",
                "baedalys",
                "etc",
                "",
                "",
                "",
                "",
                "",
                "",
                ""
            ]
        },
        type: {
            D: false,    // 배달
            P: false,      // 포장
            O: false,       // 매장
        },
        pay: {
            prePaid: false,        // 선불
            paidCard: false,   // 후불카드
            paidCash: false,   // 후불현금
        },
        sale: 0
    }

    @computed
    get getOrderChannelView() {
        return this._st_order_channel_view.channel;
    }

    @computed
    get getOrderChannelListView() {
        return this._st_order_channel_view.channelList;
    }

    @action
    setOrderChannelView(key, value) {
        this._st_order_channel_view.channel = { ...this._st_order_channel_view.channel, [key]: value }
    }

    @computed
    get getOrderTypeView() {
        return this._st_order_channel_view.type;
    }

    @action
    setOrderTypeView(key, value) {
        this._st_order_channel_view.type = { ...this._st_order_channel_view.type, [key]: value }
    }

    @computed
    get getOrderPayView() {
        return this._st_order_channel_view.pay;
    }

    @action
    setOrderPayView(key, value) {
        this._st_order_channel_view.pay = { ...this._st_order_channel_view.pay, [key]: value }
    }

    @computed
    get getOrderSaleView() {
        return this._st_order_channel_view.sale;
    }
    setOrderSaleView(value) {
        this._st_order_channel_view.sale = value
    }

    @action
    setInitChannel(obj) {
        if (obj === "channel") {
            this._st_order_channel_view.channel = {
                baemin: false,      // 배민
                baemin1: false,     // 배민1
                yogiyo: false,      // 요기요
                yogiyoexpress: false,     // 익스프레스
                eats: false,     // 쿠팡
                wmpo: false,    	// 위메프오
                specialdelivery: false, // 배달특급
                ddangyo: false,     // 땡겨요
                mukkebi: false,     // 먹깨비
                daeguro: false,     // 대구로
                incheoneum: false,  // 인천이음
                baedalys: false,    // 배달양산
                etc: false,         // 기타
            }
        } else if (obj === "type") {
            this._st_order_channel_view.type = {
                D: false,    // 배달
                P: false,      // 포장
                table: false,       // 매장
            }
        } else if (obj === "pay") {
            this._st_order_channel_view.pay = {
                prePaid: false,        // 선불
                paidCard: false,   // 후불카드
                paidCash: false,   // 후불현금
            }
        } else if (obj === "amount") {
            this._st_order_channel_view.sale = 0
        }

    }
    //@observable
    _st_sale_regist_info = {
        orderChannel: "",
        orderType: "",
        paymentType: "",
        orderChannelTxt: "",
        orderTypeTxt: "",
        paymentTypeTxt: "",
        paymentAmount: 0,
    }

    @computed
    get getOrderRegistList() {
        return this._st_sale_regist_info;
    }

    setInitRegistList() {
        this._st_sale_regist_info = {
            orderChannel: "",
            orderType: "",
            paymentType: "",
            orderChannelTxt: "",
            orderTypeTxt: "",
            paymentTypeTxt: "",
            paymentAmount: 0,
        }
    }

    setInitAmount() {
        this._st_sale_regist_info.paymentAmount = 0
    }

    setOrderRegistList(obj, txt, key) {
        if (obj == "channel") {
            this._st_sale_regist_info.orderChannelTxt = txt
            this._st_sale_regist_info.orderChannel = key
        } else if (obj == "type") {
            this._st_sale_regist_info.orderTypeTxt = txt
            this._st_sale_regist_info.orderType = key
        } else if (obj == "pay") {
            this._st_sale_regist_info.paymentTypeTxt = txt
            this._st_sale_regist_info.paymentType = key
        } else {
            this._st_sale_regist_info.paymentAmount = key //금액
        }
    }

    //total
    @observable
    _st_total_regist_info = {
        cnt: 0,
        money: 0
    }

    setInitTotalList() {
        this._st_total_regist_info = {
            cnt: 0,
            money: 0
        }
    }

    @computed
    get getTotalRegistInfo() {
        return this._st_total_regist_info;
    }

    @action
    setTotalRegistInfo(key, value) {
        this._st_total_regist_info = { ...this._st_total_regist_info, [key]: value }
    }


    @observable
    _st_sale_regist_list = [];

    setInitOrderRegistAdd() {
        this._st_sale_regist_list = []
    }

    get getOrderRegistAdd() {
        return this._st_sale_regist_list;
    }

    @action
    setOrderRegistAdd(list, flag) {
        if (flag == "del") {
            this._st_sale_regist_list = ""
            this._st_sale_regist_list = list
        } else {
            this._st_sale_regist_list.push(list)
        }
    }

    //errCnt
    @observable
    _st_sale_regist_err = 0

    @computed
    get getSaleRegistErr() {
        return this._st_sale_regist_err;
    }

    @action
    setSaleRegistErr(cnt) {
        this._st_sale_regist_err = cnt;
    }

    //배민 포스에서만 처리
    @observable
    _st_baemin_fail_detail = {}

    @computed
    get getBaeminFailDetail() {
        return this._st_baemin_fail_detail;
    }

    @action
    setBaeminFailDetail(obj) {
        this._st_baemin_fail_detail = obj;
    }


    //pollingList
    @observable
    _st_order_polling_list = []

    @computed
    get getOrderPollingList() {
        return this._st_order_polling_list;
    }

    @action
    setOrderPollingList(list) {
        return this._st_order_polling_list = list;
    }

    // 완료주문 내 취소 경우 (먹깨비)
    @observable
    _st_completed_cancel = false;

    get getCompletedCancel() {
        return this._st_completed_cancel;
    }

    @action
    setCompletedCancel(val) {
        this._st_completed_cancel = val;
    }
}

export default new OrderStore();